// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld/base/core';
import userGroupSelector from 'text!html/userGroupSelector.html';
import 'myWorld/controls/userGroups/userGroupsManager';
import './formComponent';

/**
 * Input for the sharing field. Shows up as a multilevel menu
 * @name UserGroupSelector
 * @constructor
 * @extends {FormComponent}
 */
myw.UserGroupSelector = myw.FormComponent.extend({
    template: _.template(
        $(userGroupSelector)
            .filter('#user-group-selector-template')
            .html()
    ),

    events: {
        'click .group-selector-button': 'toggleMenu'
    },

    initialize(options) {
        myw.FormComponent.prototype.initialize.call(this, options);
        this.options = options;
        this.isOpen = false;
        this.isSubMenu = typeof options.isSubMenu === 'undefined' ? false : options.isSubMenu;
    },

    render(options) {
        if (!this.isSubMenu) {
            this.$el.html(this.template());
            this.list = $('<ul>', { class: 'group-selector-with-input' }).appendTo('body');

            $(document).on('mousedown', event => {
                const target = $(event.target);
                if (
                    !target.closest('.group-selector-button').length &&
                    !target.closest('.group-selector-with-input').length
                ) {
                    this.hide();
                }
            });
        } else {
            this.setElement($('<ul>', { class: 'group-selector' }).appendTo('body'));
            this.list = this.$el;
        }
        if (options && options.parent) {
            this.parent = options.parent;
            this.parent.append(this.$el);
        }
        myw.FormComponent.prototype.render.call(this, options);
        $(window)
            .resize(() => {
                this.positionList();
            })
            .resize();

        this.list.menu().on('menuselect', (event, ui) => {
            this.selectValue(ui.item);
        });

        return this;
    },

    positionList() {
        if (this.list.is(':visible')) return; // Don't reposition when its already being displayed
        const top = this.$el.offset().top + this.$el.height();
        const left = this.$el.offset().left;

        this.list.css({
            top: top,
            left: left,
            'max-height': $(window).height() - top,
            'overflow-y': 'auto',
            'overflow-x': 'hidden'
        });
    },

    populateOptions() {
        return this.options.system.getGroupsIds().then(groupIds => {
            const groups = this._processGroupIds(groupIds);

            this.list.empty();
            let listItem;

            _.each(groups, group => {
                listItem = $('<li>')
                    .attr('data', group.group)
                    .append($('<div>', { text: group.name }));
                this.list.append(listItem);
            });

            const manageGroupsBtn = $('<li>', { role: 'no-select', class: 'edit-btn' }).append(
                $('<div>', { text: this.msg('edit_btn_title') })
            );

            this.list.append(manageGroupsBtn);

            this.list.menu('refresh');
            this.translate(this.$el);

            return this.$el;
        });
    },

    toggleMenu() {
        if (this.$el.attr('disabled') === 'disabled') return;

        if (this.isOpen) {
            this.hide();
        } else {
            this.populateOptions().then(() => {
                this.positionList();
                this.list.show();
                this.isOpen = true;
            });
        }
    },

    hide() {
        this.list.hide();
        this.isOpen = false;
    },

    /*
     * Creates a group object for each groupId
     */
    _processGroupIds(groupIds) {
        let splitGroup, groupObj;

        const groups = _.map(groupIds, group => {
            splitGroup = group.split(':');
            groupObj = {
                owner: splitGroup[0],
                name: splitGroup[1],
                group: group
            };
            return groupObj;
        });

        const refactoredGroups = [];
        let name;

        //Add the owner in brackets to the group names that are ambiguous
        _.each(groups, group => {
            if (_.where(groups, { name: group.name }).length > 1) {
                name = `${group.name} (${group.owner})`;
            } else {
                name = group.name;
            }

            refactoredGroups.push(_.extend(_.clone(group), { name: name }));
        });

        return _.sortBy(refactoredGroups, group => group.name.toLowerCase());
    },

    selectValue(item) {
        if (item.attr('role') !== 'no-select') {
            const displayVal = $.trim(item.text());
            this.$('input').val(displayVal);

            this.selectedOption =
                typeof item.attr('data') !== 'undefined' ? item.attr('data') : displayVal;
        } else if (item.hasClass('edit-btn')) {
            this.showManageDialog();
        }
        if (!this.isSubMenu) this.toggleMenu();
    },

    setValue(value) {
        this.selectedOption = value;
        const displayVal = value.split(':')[1];
        this.$('input').val(displayVal);
    },

    getValue() {
        return this.selectedOption;
    },

    /*
     * Shows the bookmark window.
     */
    showManageDialog() {
        new myw.UserGroupsManager({ system: this.options.system });
    }
});

export default myw.UserGroupSelector;
